<template>

  <div id="buttomRight" style="width: 600px;height:400px;"></div>
</template>

<script>
  import echarts from 'echarts'

  export default {

    data() {
      return {

        dataXList: [],
        data1: [],
        data2: [],
      }

    },
    props: {
      record: {
        type: Array,
      },
    },
    watch: {
      record: {
        handler: function(newVal) {
          if (!newVal) {
            return
          }

          for (var i = 0; i < newVal.length; i++) {

            this.dataXList.push(this.dateFormat("YYYY-mm-dd", new Date(newVal[i].days)));
            this.data1.push(newVal[i].sendSum);
            this.data2.push(newVal[i].receiveSum);
          }
          
          this.drawLine();
        },

      },

    },

    mounted() {

    },
    methods: {

      // 格式化日期
      dateFormat(fmt, date) {
        let ret;
        const opt = {
          "Y+": date.getFullYear().toString(), // 年
          "m+": (date.getMonth() + 1).toString(), // 月
          "d+": date.getDate().toString(), // 日
          "H+": date.getHours().toString(), // 时
          "M+": date.getMinutes().toString(), // 分
          "S+": date.getSeconds().toString() // 秒
          // 有其他格式化字符需求可以继续添加，必须转化成字符串
        };
        for (let k in opt) {
          ret = new RegExp("(" + k + ")").exec(fmt);
          if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
          };
        };
        return fmt;
      },

      drawLine() {


        var chartDom = document.getElementById('buttomRight');
        var myChart = echarts.init(chartDom);
        var option;

        option = {
          title: {
            text: '收发字节数',
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: ['发送报文条数', '为收到回复报文条数']
          },

          /* 选择其他图标展示形式 */
          /* toolbox: {
            show: true,
            feature: {
              dataView: {
                show: true,
                readOnly: false
              },
              magicType: {
                show: true,
                type: ['line', 'bar']
              },
              restore: {
                show: true
              },
              saveAsImage: {
                show: true
              }
            }
          }, */
          calculable: true,
          xAxis: [{
            type: 'category',
            data: this.dataXList,
          }],
          yAxis: [{
            type: 'value'
          }],
          series: [{
              name: '发送报文条数',
              type: 'bar',
              data: this.data1,
              markPoint: {
                data: [{
                    type: 'max',
                    name: '最大值'
                  },
                  {
                    type: 'min',
                    name: '最小值'
                  }
                ]
              },
              markLine: {
                data: [{
                  type: 'average',
                  name: '平均值'
                }]
              }
            },
            {
              name: '为收到回复报文条数',
              type: 'bar',
              data: this.data2,
              markPoint: {
                data: [{
                    name: '最高',
                    value: 442,
                    xAxis: 2,
                    yAxis: 442
                  },
                  {
                    name: '最低',
                    value: 123,
                    xAxis: 1,
                    yAxis: 123
                  }
                ]
              },
              markLine: {
                data: [{
                  type: 'average',
                  name: '平均值'
                }]
              }
            }
          ]
        };

        option && myChart.setOption(option);


      }

    }
  }
</script>

<style>
</style>
